<a *ngIf="isVisible" [href]="registrationRoute" shrdUicButton [variant]="$any(buttonVariant)" class="m-0">
  {{ 'header.account.completeRegistration' | i18next }}
</a>
